import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, Routes } from '@angular/router';

import { AgreementDetailPage } from '@lib/agreement-detail-page';
import { AgreementsPage } from '@lib/agreements-page';
import { ChargeableHoursPage } from '@lib/chargeable-hours-page';
import { ClientDetailPage } from '@lib/client-detail-page';
import { ClientsPage } from '@lib/clients-page';
import { CommissionPage } from '@lib/commission-page';
import { DashboardPage } from '@lib/dashboard-page';
import { ErrorPage } from '@lib/error-page';
import { InvoicesPage } from '@lib/invoices-page';
import { Layout } from '@lib/layout';
import { LoginPage } from '@lib/login-page';
import { ProductDetailPage } from '@lib/product-detail-page';
import { ProductsPage } from '@lib/products-page';
import { ProjectsPage } from '@lib/projects-page';
import { ResourcesPage } from '@lib/resources-page';
import { UsersPage } from '@lib/users-page';

import { Auth } from './service';

export const routes: Routes = [
  {
    path: '',
    component: Layout,
    children: [
      {
        path: '',
        redirectTo: 'app/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginPage,
      },
      {
        path: 'app',
        canActivate: [
          (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
            const auth = inject(Auth);
            const router = inject(Router);

            const url: string = state.url;
            if (auth.isLoggedIn()) {
              return true;
            }
            auth.redirectUrl = url;

            router.navigateByUrl('/login');
            return false;
          },
        ],
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            component: DashboardPage,
          },
          {
            path: 'client-accounts',
            loadChildren: () => [
              { path: '', component: ClientsPage, pathMatch: 'full' },
              {
                path: 'view/:clientCode',
                component: ClientDetailPage,
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'products',
            loadChildren: () => [
              { path: '', component: ProductsPage, pathMatch: 'full' },
              { path: ':clientCode', component: ProductsPage, pathMatch: 'full' },
              {
                path: 'view/:jobNumber',
                component: ProductDetailPage,
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'agreements',
            loadChildren: () => [
              { path: '', component: AgreementsPage, pathMatch: 'full' },
              { path: ':clientCode', component: AgreementsPage, pathMatch: 'full' },
              {
                path: 'view/:agreementNumber',
                component: AgreementDetailPage,
                pathMatch: 'full',
              },
              {
                path: ':clientCode/:jobNumber',
                component: AgreementsPage,
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'resources',
            loadComponent: () => ResourcesPage,
          },

          {
            path: 'users',
            loadComponent: () => UsersPage,
          },
          {
            path: 'hours',
            loadChildren: () => [
              {
                path: '',
                component: ChargeableHoursPage,
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'commission',
            loadChildren: () => [
              {
                path: '',
                component: CommissionPage,
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'projects',
            loadComponent: () => ProjectsPage,
          },
          {
            path: 'retained',
            loadComponent: () => InvoicesPage,
          },
        ],
      },
      {
        path: '**',
        component: ErrorPage,
      },
    ],
  },
];
